:host {
  display: block;
}

.related-products-group-card {
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 1;
  outline: none;
  display: flex;
  align-items: center;
}

:host(:not([dir="rtl"])) .related-products-group-card {
  text-align: left;
}

:host([dir="rtl"]) .related-products-group-card {
  text-align: right;
}

@media screen and (max-width: 979px) {
  .related-products-group-card {
    min-height: 60px;
  }

  :host(:not([dir="rtl"])) .related-products-group-card {
    padding: 10px 10px 10px 20px;
  }

  :host([dir="rtl"]) .related-products-group-card {
    padding: 10px 20px 10px 10px;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card {
    min-height: 86px;
    padding: 14px 16px;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card::before {
    content: "";
    position: absolute;
    top: -1px;
    right: 0;
    left: 0;
    height: 2px;
    opacity: 0;
    background-color: #3dcd58;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card:hover::before, .related-products-group-card:focus::before {
    opacity: 1;
  }
}

.related-products-group-card__image {
  object-fit: contain;
}

@media screen and (max-width: 979px) {
  .related-products-group-card__image {
    width: 25px;
    height: 25px;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card__image {
    width: 40px;
    height: 40px;
  }
}

.related-products-group-card__name {
  font-size: 1rem;
  font-weight: normal;
}

:host(:not([dir="rtl"])) .related-products-group-card__name {
  margin: 0 0 0 15px;
}

:host([dir="rtl"]) .related-products-group-card__name {
  margin: 0 15px 0 0;
}

@media screen and (max-width: 979px) {
  .related-products-group-card__name {
    line-height: 1.125rem;
  }

  :host(:not([dir="rtl"])) .related-products-group-card__name {
    margin-right: 15px;
  }

  :host([dir="rtl"]) .related-products-group-card__name {
    margin-left: 15px;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card__name {
    line-height: 1.5rem;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card:hover .related-products-group-card__name, .related-products-group-card:focus .related-products-group-card__name {
    font-weight: bold;
    text-decoration: underline;
  }
}

.related-products-group-card__title-count {
  opacity: 0.5;
  font-weight: normal;
}

@media screen and (min-width: 980px) {
  .related-products-group-card:hover .related-products-group-card__title-count, .related-products-group-card:focus .related-products-group-card__title-count {
    font-weight: bold;
  }
}

@media screen and (max-width: 979px) {
  .related-products-group-card__icon--mobile {
    opacity: 0.5;
  }

  :host(:not([dir="rtl"])) .related-products-group-card__icon--mobile {
    margin-left: auto;
  }

  :host([dir="rtl"]) .related-products-group-card__icon--mobile {
    margin-right: auto;transform: scale(-1);
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card__icon--mobile {
    display: none;
  }
}

@media screen and (max-width: 979px) {
  .related-products-group-card__icon--desktop {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card__icon--desktop {
    position: absolute;
    top: 12px;
    opacity: 0;
  }

  :host(:not([dir="rtl"])) .related-products-group-card__icon--desktop {
    right: 15px;
  }

  :host([dir="rtl"]) .related-products-group-card__icon--desktop {
    left: 15px;
  }
}

@media screen and (min-width: 980px) {
  .related-products-group-card:hover .related-products-group-card__icon--desktop, .related-products-group-card:focus .related-products-group-card__icon--desktop {
    opacity: 0.5;
  }
}